module.exports = __webpack_public_path__ + "static/img/garz.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/garz.png
// module id = uCEw
// module chunks = 10